import React from "react";
import { Link } from "react-router-dom";
import { FolioHome } from "../app-template/AppContent";
import AppNavigation from "./AppNavigation";

function AppHeader() {
  return (
    <header className="app-header">
      <h1 className="app-name">
        <Link to={FolioHome.path}>
          <span>Martin Duggan</span>
          <span>Product Designer</span>
        </Link>
      </h1>
      <AppNavigation />
    </header>
  );
}

export default AppHeader;
